import { useEffect } from 'react';
import * as R from 'ramda';
import { isNil } from 'ramda';

const initAmendment = ({
  courseIsAmendment,
  isKnownAmendment,
  selectedCategories,
  getObjectiveCategoriesForCollege,
  setObjectiveCategoryForCollege
}) => {
  const selectObjectiveCategoryForColleges = (colleges) => {
    const objectiveCategoryToSelect = R.compose(
      R.prop('objectiveCategory'),
      R.defaultTo({}),
      R.head,
      R.values,
      R.filter(
        R.both(
          R.propEq('isSelected', true),
          R.propSatisfies(
            R.compose(R.not, R.isNil),
            'objectiveCategory'
          )
        )
      )
    )(selectedCategories);

    if (!isNil(objectiveCategoryToSelect)) {
      R.forEach(selectedCollege => {
        const objectiveCategories = getObjectiveCategoriesForCollege(selectedCollege);
        const identicalObjectiveCategory = R.find(R.eqProps('option', objectiveCategoryToSelect), objectiveCategories);

        if (!R.isNil(identicalObjectiveCategory)) {
          setObjectiveCategoryForCollege(selectedCollege, identicalObjectiveCategory);
        }
      })(colleges);
    }
  };

  useEffect(() => {
    if (courseIsAmendment && isKnownAmendment) {
      // Dans le cas d'un avenant connu, on doit automatiquement sélectionner la même catégorie dans les collèges qui n'étaient pas présents dans le contrat d'origine

      const selectedColleges = R.compose(
        R.keys,
        R.filter(R.propEq('isSelected', true))
      )(selectedCategories);

      const selectedObjectiveCategories = R.compose(
        R.reject(R.isNil),
        R.pluck('objectiveCategory'),
        R.values
      )(selectedCategories);

      if (R.length(selectedObjectiveCategories) < R.length(selectedColleges)) {
        selectObjectiveCategoryForColleges(selectedColleges);
      }
    }
  }, []);

  useEffect(() => {
    if (courseIsAmendment && isKnownAmendment) {
      const selectedCollegesWithoutObjectiveCategory = R.compose(
        R.keys,
        R.reject(R.propSatisfies(R.compose(R.not, R.isNil), 'objectiveCategory')),
        R.filter(R.propEq('isSelected', true))
      )(selectedCategories);

      selectObjectiveCategoryForColleges(selectedCollegesWithoutObjectiveCategory);
    }
  }, [selectedCategories]);
};

export default initAmendment;
